/** @param {IRootState} state */
export const selectUserIdentifier = (state) => {
  return state.auth.currentUser?.account ?? '';
};
